import { debounce } from 'throttle-debounce';
import { ref, nextTick, onMounted, onBeforeUnmount } from 'vue';

export default customCallbackOnScroll => {
  const scrollTargetNode = ref(undefined);
  const isInitialCallbackOnScrollTrigger = ref(true);

  onMounted(() => {
    initCallbackOnScroll();
  });

  onBeforeUnmount(() => {
    scrollTargetNode.value?.removeEventListener('scroll', callbackOnScroll);
  });

  async function initCallbackOnScroll() {
    scrollTargetNode.value?.removeEventListener('scroll', callbackOnScroll);

    await nextTick();
    if (!scrollTargetNode.value) {
      scrollTargetNode.value = window;
    }
    await nextTick();
    scrollTargetNode.value.addEventListener('scroll', callbackOnScroll);
    await nextTick();

    if (isInitialCallbackOnScrollTrigger.value) {
      callbackOnScroll(callbackOnScroll);
    }
  }

  function callbackOnScroll() {
    if (customCallbackOnScroll) {
      customCallbackOnScroll();
    } else {
      console.warn('callbackOnScroll is not implemented'); // eslint-disable-line no-console
    }
  }

  return {
    scrollTargetNode,
    isInitialCallbackOnScrollTrigger,
    callbackOnScroll,
    initCallbackOnScroll
  };
};
